import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {VideoControlIcon} from '../../../components/icons'

/**
 * PD Plus Video Component
 */
export const PDPlusVideoComponent = ({
    videoSelect,
    videoID,
    videoTitle,
    videoAutoPlay,
    videoMute,
    videoLoop,
    videoModalPopup,
    videoPoster,
    imgAlt,
    desktopIframeHTML,
    mobileIframeHTML
}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    const renderIframe = () => {
        switch (videoSelect) {
            case 'youtube':
                return (
                    <Box>
                        <iframe
                            src={`https://www.youtube.com/embed/${videoID}?enablejsapi=1&autoplay=${
                                videoAutoPlay ? 1 : 0
                            }&mute=${videoMute ? 1 : 0}&loop=${videoLoop ? 1 : 0}`}
                            title={videoTitle}
                            allow="autoplay; encrypted-media"
                            frameBorder="0"
                            style={{width: '100%', height: '500px'}}
                        />
                    </Box>
                )
            case 'vimeo':
                return (
                    <Box className="embed-responsive embed-responsive-16by9">
                        <iframe
                            src={`https://player.vimeo.com/video/${videoID}?badge=0&autopause=0&player_id=0&autoplay=${
                                videoAutoPlay ? 1 : 0
                            }&muted=${videoMute ? 1 : 0}&loop=${videoLoop ? 1 : 0}`}
                            title={videoTitle}
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                            frameBorder="0"
                            style={{width: '100%', height: '500px'}}
                        />
                    </Box>
                )
            case 'dailymotion':
                return (
                    <Box>
                        <iframe
                            className="embed-responsive-item"
                            src={`https://www.dailymotion.com/embed/video/${videoID}?autoplay=${
                                videoAutoPlay ? 1 : 0
                            }&mute=${videoMute ? 1 : 0}&loop=${videoLoop ? 1 : 0}`}
                            title={videoTitle}
                            frameBorder="0"
                            style={{width: '100%', height: '500px'}}
                        />
                    </Box>
                )
            case 'custom-url':
                return (
                    <>
                        {/* Desktop iframe (≥768px) */}
                        <Box
                            dangerouslySetInnerHTML={{__html: desktopIframeHTML}}
                            display={{base: 'none', md: 'block'}}
                        />

                        {/* Mobile iframe (≤767.99px) with fallback */}
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: mobileIframeHTML || desktopIframeHTML
                            }}
                            display={{base: 'block', md: 'none'}}
                        />
                    </>
                )
            default:
                return null
        }
    }

    return (
        <>
            {videoModalPopup ? (
                <Box
                    aria-label={videoTitle}
                    maxW={'1920px'}
                    m={'0 auto'}
                    backgroundColor={'black'}
                    position={'relative'}
                >
                    <img src={videoPoster?.url} alt={imgAlt} />
                    <Button
                        variant="unstyled"
                        onClick={onOpen}
                        position="absolute"
                        top={'50%'}
                        left={0}
                        right={0}
                        margin={'0 auto'}
                        transform="translateY(-50%)"
                        w={12}
                        h={12}
                    >
                        <VideoControlIcon />
                    </Button>

                    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Video</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>{renderIframe()}</ModalBody>
                        </ModalContent>
                    </Modal>
                </Box>
            ) : (
                <Box maxW={'1920px'} m={'0 auto'} backgroundColor={'black'}>
                    {renderIframe()}
                </Box>
            )}
        </>
    )
}

PDPlusVideoComponent.propTypes = {
    videoSelect: PropTypes.string,
    videoID: PropTypes.string,
    videoTitle: PropTypes.string,
    videoAutoPlay: PropTypes.bool,
    videoMute: PropTypes.bool,
    videoLoop: PropTypes.bool,
    videoModalPopup: PropTypes.bool,
    videoPoster: PropTypes.object,
    desktopIframeHTML: PropTypes.string,
    mobileIframeHTML: PropTypes.string,
    imgAlt: PropTypes.string
}

export default PDPlusVideoComponent
